import { Button } from '@cian/ui-kit';
import { IconProductDateTime16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface IFlatViewButtonProps {
  disabled?: boolean;
  onClick(): void;
}

export const FlatViewButton: React.FC<IFlatViewButtonProps> = ({ onClick, disabled }) => {
  return (
    <Button
      theme="stroke_primary"
      size="M"
      onClick={onClick}
      disabled={disabled}
      fullWidth={false}
      beforeIcon={<IconProductDateTime16 color="current_color" />}
    >
      Записаться на просмотр
    </Button>
  );
};
